(()=>{
  'use strict';
  const reduceMotion=()=>matchMedia('(prefers-reduced-motion: reduce)').matches;
  function splitDescription(section){
    const source=section.querySelector('[data-description-content]');
    if(!source)return;
    const sizeLabel=section.querySelector('[data-description-size]');
    const size=source.textContent.match(/\bSize:\s*(\d+(?:\.\d+)?(?:\s*[x×]\s*\d+(?:\.\d+)?)?\s*(?:ml|mL|g|oz))\b/);
    if(sizeLabel&&size){sizeLabel.textContent=size[1];sizeLabel.hidden=false;}
    const titles=new Map([['details','The details'],['description','The details'],['how to use','How to use'],['directions','How to use'],['ingredients','Ingredients'],['composition','Composition'],['benefits','Benefits']]);
    const headings=[...source.querySelectorAll('h2,h3,h4')].filter(el=>titles.has(el.textContent.trim().toLowerCase()));
    if(!headings.length)return;
    const parts=[];
    for(let i=-1;i<headings.length;i++){
      const range=document.createRange();
      if(i<0)range.setStart(source,0);else range.setStartAfter(headings[i]);
      if(i+1<headings.length)range.setEndBefore(headings[i+1]);else range.setEnd(source,source.childNodes.length);
      const fragment=range.cloneContents();
      if(!fragment.textContent.trim()&&!fragment.querySelector('img,video,iframe,table'))continue;
      parts.push({title:i<0?'The details':titles.get(headings[i].textContent.trim().toLowerCase()),fragment});
    }
    if(!parts.length)return;
    // If an unusual description cannot be split losslessly, keep the original.
    const original=source.cloneNode(true);
    original.querySelectorAll('h2,h3,h4').forEach(el=>{if(titles.has(el.textContent.trim().toLowerCase()))el.remove();});
    const normalise=text=>text.replace(/\s/g,'');
    if(normalise(original.textContent)!==normalise(parts.map(part=>part.fragment.textContent).join('')))return;
    const content=document.createDocumentFragment();
    parts.forEach((part,index)=>{
      const details=document.createElement('details');
      details.open=index===0;
      const summary=document.createElement('summary');summary.textContent=part.title;
      const body=document.createElement('div');body.className='rte';body.append(part.fragment);
      details.append(summary,body);content.append(details);
    });
    section.querySelector('[data-original-description]').replaceWith(content);
  }
  function initialise(section){
    if(section.dataset.pdpReady)return;
    section.dataset.pdpReady='true';
    splitDescription(section);
    const zoom=document.createElement('dialog');
    zoom.className='product-zoom-dialog';
    zoom.setAttribute('aria-label','Enlarged product image');
    const close=document.createElement('button');
    close.type='button';close.className='button product-zoom-close';close.textContent='Close image';
    const image=document.createElement('img');
    zoom.append(close,image);section.append(zoom);
    let zoomOpener;
    close.addEventListener('click',()=>zoom.close());
    zoom.addEventListener('close',()=>zoomOpener?.focus({preventScroll:true}));
    zoom.addEventListener('click',event=>{if(event.target===zoom)zoom.close();});
    section.addEventListener('click',event=>{
      const link=event.target.closest('[data-product-zoom]');
      if(!link||event.ctrlKey||event.metaKey||event.shiftKey||event.altKey)return;
      event.preventDefault();zoomOpener=link;
      image.alt=link.querySelector('img')?.alt||'';image.src=link.href;
      zoom.showModal();close.focus();
    });
    const gallery=section.querySelector('.product-gallery');
    const controls=section.querySelector('[data-gallery-controls]');
    if(gallery&&controls){
      controls.hidden=false;
      const slides=[...gallery.children];
      let current=0;
      const update=()=>{
        current=slides.reduce((best,slide,index)=>Math.abs(slide.offsetLeft-slides[0].offsetLeft-gallery.scrollLeft)<Math.abs(slides[best].offsetLeft-slides[0].offsetLeft-gallery.scrollLeft)?index:best,0);
        controls.querySelector('[data-gallery-index]').textContent=current+1;
        controls.querySelector('[data-gallery-step="-1"]').disabled=current===0;
        controls.querySelector('[data-gallery-step="1"]').disabled=current===slides.length-1;
        slides.forEach((slide,index)=>{if(index!==current)slide.querySelectorAll('video').forEach(video=>video.pause());});
      };
      const move=step=>{const target=slides[Math.max(0,Math.min(slides.length-1,current+step))];gallery.scrollTo({left:target.offsetLeft-slides[0].offsetLeft,behavior:reduceMotion()?'instant':'smooth'});};
      controls.addEventListener('click',event=>{const button=event.target.closest('[data-gallery-step]');if(button)move(Number(button.dataset.galleryStep));});
      gallery.addEventListener('keydown',event=>{if(event.target!==gallery)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1);}});
      gallery.addEventListener('scroll',update,{passive:true});
      update();
    }
  }
  const initialiseAll=()=>document.querySelectorAll('[data-product-section]').forEach(initialise);
  initialiseAll();
  new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1&& (node.matches('[data-product-section]')||node.querySelector('[data-product-section]'))))){initialiseAll();updateBar();}}).observe(document.body,{childList:true,subtree:true});
  function updateBar(){
    const section=document.querySelector('[data-product-section]');
    const bar=section?.querySelector('[data-mobile-purchase]');
    const purchase=section?.querySelector('[data-primary-purchase]');
    if(!bar||!purchase)return;
    const keyboardOpen=window.visualViewport&&window.innerHeight-window.visualViewport.height>150;
    bar.hidden=!matchMedia('(max-width: 899px)').matches||purchase.getBoundingClientRect().bottom>=0||section.getBoundingClientRect().bottom<=0||!!document.querySelector('dialog[open]')||keyboardOpen;
  }
  let ticking=false;
  const schedule=()=>{if(!ticking){ticking=true;requestAnimationFrame(()=>{ticking=false;updateBar();});}};
  addEventListener('scroll',schedule,{passive:true});addEventListener('resize',schedule);window.visualViewport?.addEventListener('resize',schedule);
  document.addEventListener('click',event=>{const button=event.target.closest('[data-return-purchase]');if(!button)return;const purchase=button.closest('[data-product-section]').querySelector('.product-purchase');purchase.scrollIntoView({block:'center',behavior:reduceMotion()?'instant':'smooth'});purchase.focus({preventScroll:true});});
  document.addEventListener('toggle',event=>{
    if(event.target.matches('dialog'))updateBar();
    if(!event.target.matches('.product-faqs details')||!event.target.open)return;
    event.target.closest('.product-faqs').querySelectorAll('details[open]').forEach(details=>{if(details!==event.target)details.open=false;});
  },true);
  updateBar();
})();
